import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PublishStepper } from '../../context-discovery-services/models/publish-stepper.model';

@Component({
  selector: 'adminapp-identify-assets-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  private _modelId: any;
  private _isPublishInProgress: boolean;
  private _completeOnboardingStatus: PublishStepper[];
  private _equipmentIriInContext: string;

  @Output()
  layoutToViewAssetsEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  set equipmentIriInContext(assetIri: string) {
    if (this._equipmentIriInContext !== assetIri) {
      this._equipmentIriInContext = assetIri;
    }
  }

  @Input()
  set modelId(idOfModel: string) {
    if (this._modelId === idOfModel) {
      return;
    }
    this._modelId = idOfModel;
  }

  @Input()
  set isPublishInProgress(isPublishInProgress: any) {
    if (this._isPublishInProgress !== isPublishInProgress) {
      this._isPublishInProgress = isPublishInProgress;
    }
  }

  @Input()
  set completeOnboardingStatus(completeOnboardingStatus: any) {
    if (JSON.stringify(this._completeOnboardingStatus) !== JSON.stringify(completeOnboardingStatus)) {
      this._completeOnboardingStatus = completeOnboardingStatus;
    }
  }

  constructor() {
  }

  ngOnInit(): void {
  }

  relayEventFromwidget(event) {
    this.layoutToViewAssetsEventEmitter.emit(event);
  }
}
